!function webpackUniversalModuleDefinition(e, t) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = t(require("@driftt/api-types"));else if ("function" === typeof define && define.amd) define(["@driftt/api-types"], t);else {
    var r = "object" === typeof exports ? t(require("@driftt/api-types")) : t(e["@driftt/api-types"]);
    for (var o in r) {
      ("object" === typeof exports ? exports : e)[o] = r[o];
    }
  }
}(window, function (e) {
  return function (e) {
    var t = {};
    function __webpack_require__(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, __webpack_require__), o.l = !0, o.exports;
    }
    return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, r) {
      __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, __webpack_require__.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (e, t) {
      if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
      if (4 & t && "object" === typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (__webpack_require__.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        __webpack_require__.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function getDefault() {
        return e.default;
      } : function getModuleExports() {
        return e;
      };
      return __webpack_require__.d(t, "a", t), t;
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 138);
  }({
    11: function _(e, t, r) {
      "use strict";

      function _arrayLikeToArray(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, o = new Array(t); r < t; r++) {
          o[r] = e[r];
        }
        return o;
      }
      r.d(t, "a", function () {
        return _arrayLikeToArray;
      });
    },
    138: function _(e, t, r) {
      e.exports = r(50);
    },
    16: function _(e, t, r) {
      "use strict";

      r.d(t, "a", function () {
        return _unsupportedIterableToArray;
      });
      var o = r(11);
      function _unsupportedIterableToArray(e, t) {
        if (e) {
          if ("string" === typeof e) return Object(o.a)(e, t);
          var r = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(r) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Object(o.a)(e, t) : void 0;
        }
      }
    },
    18: function _(e, t, r) {
      "use strict";

      var o = r(7),
        n = {
          QA: {},
          EU: {},
          US: {}
        };
      t.a = Object(o.a)(Object(o.a)({}, window.DRIFT_CONFIG || {}), n[window.DRIFT_REGION || ("PRODUCTION" === window.__ENV__ ? "US" : "QA")]);
    },
    26: function _(e, t, r) {
      "use strict";

      var o = r(11);
      var n = r(16);
      function _toConsumableArray(e) {
        return function _arrayWithoutHoles(e) {
          if (Array.isArray(e)) return Object(o.a)(e);
        }(e) || function _iterableToArray(e) {
          if ("undefined" !== typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
        }(e) || Object(n.a)(e) || function _nonIterableSpread() {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      r.d(t, "a", function () {
        return _toConsumableArray;
      });
    },
    32: function _(e, t, r) {
      "use strict";

      r.r(t);
      var o = r(26),
        n = r(4),
        a = [].concat(Object(o.a)(Object.values(n.PlaybookEditorTypes)), [n.PlaybookReportType.FORM_SUBMISSION_FAST_LANE]),
        i = Object.values(n.PlaybookMigratedTypes),
        c = Object.values(n.PlaybookMarketplaceWebTypes),
        u = Object.values(n.PlaybookChatTypes),
        b = [n.PlaybookReportType.ENTERPRISE_BOT],
        l = Object.values(n.PlaybookFastlaneTypes),
        _ = [n.PlaybookReportType.MEETING_BOOKING_BOT],
        p = [n.PlaybookReportType.EMAIL_BOTS_V2],
        s = [].concat(Object(o.a)(Object.values(n.PlaybookEmailTypes)), [n.PlaybookReportType.ABANDONED_BOOK_A_MEETING, n.PlaybookReportType.VSB_DEFAULT_PLAYBOOK]);
      r.d(t, "isFastlanePlaybook", function () {
        return y;
      }), r.d(t, "isChatPlaybook", function () {
        return d;
      }), r.d(t, "isAIPlaybook", function () {
        return O;
      }), r.d(t, "isEmailPlaybook", function () {
        return k;
      }), r.d(t, "isNewEditorPlaybook", function () {
        return T;
      }), r.d(t, "isDriftEmailPlaybook", function () {
        return w;
      }), r.d(t, "isMarketplaceWebPlaybook", function () {
        return g;
      }), r.d(t, "isMeetingBookingPlaybook", function () {
        return E;
      });
      var f = function checkInReportTypes(e) {
          return function (t) {
            return t && e.includes(t.reportType);
          };
        },
        y = f(l),
        d = f(u),
        O = f(b),
        k = f(s),
        P = f(a),
        j = f(i),
        T = function isNewEditorPlaybook(e) {
          return P(e) || j(e);
        },
        w = f(p),
        g = f(c),
        E = f(_);
    },
    4: function _(t, r) {
      t.exports = e;
    },
    50: function _(e, t, r) {
      "use strict";

      r.r(t), r.d(t, "PlaybookEditorUrlSubPath", function () {
        return o;
      }), r.d(t, "getPlaybookEditorUrlPath", function () {
        return i;
      }), r.d(t, "getPlaybookReportUrlPath", function () {
        return c;
      });
      var o,
        n = r(18),
        a = r(32);
      !function (e) {
        e.BOT_MESSAGE = "bot-message", e.BOT_FLOW = "visual-builder", e.DRIFT_LINK = "targeting/drift-link", e.EXPERIMENT = "visual-builder/experiment", e.FASTLANE_INSTALL = "install", e.FASTLANE_MAPPING = "form-mapping", e.SETTINGS = "settings", e.TARGETING = "targeting/builder";
      }(o || (o = {}));
      var i = function getPlaybookEditorUrlPath(e, t) {
          return e ? Object(a.isDriftEmailPlaybook)(e) ? "".concat(n.a.EMAIL_APP_URL, "/campaigns/editor/").concat(e.id, "/campaign-builder") : Object(a.isNewEditorPlaybook)(e) ? "/playbooks/editor/".concat(e.id).concat(t ? "/" + t : "") : "/playbooks/".concat(e.id, "/edit") : "";
        },
        c = function getPlaybookReportUrlPath(e) {
          return Object(a.isChatPlaybook)(e) || Object(a.isMeetingBookingPlaybook)(e) ? "/playbooks/chat/".concat(e.id) : Object(a.isFastlanePlaybook)(e) ? "/playbooks/fastlane/".concat(e.id) : Object(a.isMarketplaceWebPlaybook)(e) ? "/reports/playbooks/".concat(e.id) : i(e);
        };
    },
    6: function _(e, t, r) {
      "use strict";

      function _defineProperty(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = r, e;
      }
      r.d(t, "a", function () {
        return _defineProperty;
      });
    },
    7: function _(e, t, r) {
      "use strict";

      r.d(t, "a", function () {
        return _objectSpread2;
      });
      var o = r(6);
      function ownKeys(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t && (o = o.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), r.push.apply(r, o);
        }
        return r;
      }
      function _objectSpread2(e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? ownKeys(Object(r), !0).forEach(function (t) {
            Object(o.a)(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }
        return e;
      }
    }
  });
});